import { login, logout } from '@/api/login'
import { getToken, setToken, removeToken } from '@/utils/auth'

const user = {
  state: {
    // 用户信息
    userInfo: {},
    token: getToken()
  },

  mutations: {
    SET_USER_INFO: (state, info) => {
      state.userInfo = info
    },
    SET_TOKEN: (state, token) => {
      state.token = token
    },
  },

  actions: {
    login({commit}, params) {
      return new Promise((resolve, reject) => {
        login(params).then(res => {
          commit('SET_USER_INFO', res.data)
          commit('SET_TOKEN', res.data.token)
          window.localStorage.setItem("user",JSON.stringify(res.data))
          setToken(res.data.token)
          resolve(res.data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    
    logout({commit}, params) {
      return new Promise((resolve, reject) => {
          commit('SET_TOKEN', '')
          removeToken()
          commit('SET_USER_INFO', '')
          window.localStorage.setItem("user",'')
          resolve()
      })
    },
    // // 登录
    // Login({ commit }, userInfo) {
    //   const username = userInfo.username.trim()
    //   const password = userInfo.password
    //   const code = userInfo.code
    //   const uuid = userInfo.uuid
    //   return new Promise((resolve, reject) => {
    //     login(username, password, code, uuid).then(res => {
    //       setToken(res.token)
    //       commit('SET_TOKEN', res.token)
    //       resolve()
    //     }).catch(error => {
    //       reject(error)
    //     })
    //   })
    // },

    // // 获取用户信息
    // GetInfo({ commit, state }) {
    //   return new Promise((resolve, reject) => {
    //     getInfo().then(res => {
    //       const user = res.user
    //       const avatar = (user.avatar == "" || user.avatar == null) ? require("@/assets/images/profile.jpg") : process.env.VUE_APP_BASE_API + user.avatar;
    //       if (res.roles && res.roles.length > 0) { // 验证返回的roles是否是一个非空数组
    //         commit('SET_ROLES', res.roles)
    //         commit('SET_PERMISSIONS', res.permissions)
    //       } else {
    //         commit('SET_ROLES', ['ROLE_DEFAULT'])
    //       }
    //       commit('SET_NAME', user.userName)
    //       commit('SET_AVATAR', avatar)
    //       resolve(res)
    //     }).catch(error => {
    //       reject(error)
    //     })
    //   })
    // },

    // 退出系统
    LogOut({ commit, state }) {
    
          commit('SET_TOKEN', '')
          commit('SET_ROLES', [])
          commit('SET_PERMISSIONS', [])
          removeToken()
          resolve()
      
    },

    // // 前端 登出
    // FedLogOut({ commit }) {
    //   return new Promise(resolve => {
    //     commit('SET_TOKEN', '')
    //     removeToken()
    //     resolve()
    //   })
    // }
  }
}

export default user
